import React, { useState } from "react";
import {Card, CardBody, CardHeader, CardTitle, TabContent, TabPane, Nav, NavItem, NavLink, Button} from "reactstrap";
import AnalysisTableList from 'components/Analysis/AnalysisTableList';
import { useTranslate } from "react-translate";
import { useHistory } from "react-router";

const AnalysisList = () => {
    const history = useHistory();

    const t = useTranslate('analysis');

    return (
        // <div className="content dashboard">
        <Card>
            <CardBody>
                <Card>
                    <CardHeader>
                        <CardTitle className="d-flex align-content-center">
                            <div className="general-card-title-img text-primary mr-2">
                            <i className="icon-medical-device" />
                            </div>
                            <div className="general-card-title text-primary" testId="analysis_title">
                                {t("title")}
                            </div>
                        </CardTitle>
                    </CardHeader>

                    <CardBody>

                        <Button 
                            color="info" 
                            onClick={() => {
                                history.push("/admin/analysis/edition");
                            }}
                        >
                            {t("new-analysis")}
                        </Button>

                        <AnalysisTableList />
                    </CardBody>
                </Card>
            </CardBody>
        </Card>
    );
}

export default React.memo(AnalysisList);